import { createContext } from "react";

const actionsContext = createContext();

export default actionsContext;
